// extracted by mini-css-extract-plugin
export var actions = "_pu-4";
export var item = "_pu-1";
export var price = "_pu-3";
export var quantity = "_pu-2";
export var table = "_pu-0";